<template lang="html">
  <footer id="footer">
		<div class="container main-container">
			<div class="row">
				<div class="col-12 col-logo">
					<router-link to="/">
						<img src="public/images/logo-blue.svg">
					</router-link>
				</div>

				<div class="col-12 col-newsletter">
					<h6 class="title">SUSCRÍBETE A NUESTRO NEWSLETTER</h6>

					<b-form inline @submit="onSubmit">
				    <b-form-input
				    	type="email"
				    	v-model="formNewsletter.email"
				      placeholder="Email"
							required
				    ></b-form-input>

						<b-button type="submit"><i class="fa-thin fa-chevron-right"></i></b-button>
				  </b-form>
				</div>

				<div class="col-12 col-networks">
					<a class="btn-network" target="_blank" :href="$root.socialNetworks.fb">
						<i class="fa-brands fa-facebook-f"></i>
					</a>

					<a class="btn-network" target="_blank" :href="$root.socialNetworks.ig">
						<i class="fa-brands fa-instagram"></i>
					</a>

					<a class="btn-network" target="_blank" :href="$root.socialNetworks.yt">
						<i class="fa-brands fa-youtube"></i>
					</a>
				</div>

				<div class="col-12 col-links">
					<router-link to="/aviso-de-privacidad">AVISO DE PRIVACIDAD</router-link>
					<span class="sep">|</span>
					<router-link to="/terminos-y-condiciones">TÉRMINOS Y CONDICIONES</router-link>
					<span class="sep">|</span>
          <router-link to="/contrato-de-servicios-turisticos">CONTRATO DE SERVICIOS TURÍSTICOS</router-link>
					<span class="sep">|</span>
					<router-link to="/preguntas-frecuentes">PREGUNTAS FRECUENTES</router-link>
          <span class="sep">|</span>
          <span class="d-block d-sm-none"></span>
          <router-link to="/blog">BLOG</router-link>
				</div>
			</div>
		</div>

    <div class="box-copy">
      <p>
        <strong>VIAJARE®</strong> | TODOS LOS DERECHOS RESERVADOS {{ currentYear }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
	data() {
		return {
      currentYear: 0,

			formNewsletter: {
				email: null
			}
		}
	},

	methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-center',
        appendToast: true
      })
    },

    onSubmit(event) {
      event.preventDefault();

      var params = this.formNewsletter;
      var apiURL = tools.url("/api/newsletter");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Newsletter');
        // alert(response.data.response);

        for (let prop in this.formNewsletter) {
          this.formNewsletter[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
	},

  beforeMount() {
    this.currentYear = new Date().getFullYear();
  }
}
</script>
